// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import { useEffect, useState } from 'react';
import { axiosInstance } from 'src/api/axios';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';

// import required modules
import { useMediaQuery } from '@mui/material';
import { Autoplay, Pagination } from 'swiper/modules';
// import { Link, useNavigate } from 'react-router-dom';

export default function Carousel(props) {
  const [banner, setBanner] = useState([]);
  const lgUp = useMediaQuery((media) => media.breakpoints.up('lg'));
  // const navigate = useNavigate()
  // const theme = useTheme();
  useEffect(() => {
    axiosInstance.get('/banner').then((response) => {
      setBanner(response.data);
    });
  }, []);

  return (
    <>
      {banner && banner.length ? (
        <Swiper
          pagination={{
            dynamicBullets: true,
          }}
          modules={[Pagination, Autoplay]}
          className="mySwiper"
          spaceBetween={30}
          centeredSlides={true}
          autoplay={{
            delay: 7000,
            disableOnInteraction: true,
          }}
          style={{
            borderRadius: '10px',
            width: '101%',
            maxWidth: lgUp ? '75vw' : '101%',
            height: '200px',
          }}
        >
          {banner.map((item, slideIndex) => (
            <SwiperSlide key={slideIndex} style={{ minHeight: '180px', maxWidth: '100%' }}>
              {Object.keys(item.source).length ? (
                // Uncomment the Link component if you want to use it
                // <Link to={item.link}>
                <picture>
                  <source media="(min-width: 1200px)" srcSet={item.source.lg} />
                  <source media="(min-width: 650px)" srcSet={item.source.md} />
                  <img
                    src={item.source.sm}
                    alt={item.title}
                    width={'100%'}
                    height={'100%'}
                    style={{ objectFit: 'cover', maxHeight: '100%', cursor: 'pointer' }}
                    onClick={() => (window.location.href = item.link)}
                  />
                </picture>
              ) : // </Link>
              null}
            </SwiperSlide>
          ))}
        </Swiper>
      ) : null}
    </>
  );
}
